import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { AuthenticationPage } from './pages/AuthenticationPage';
import { Dashboard } from './components/Dashboard';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<AuthenticationPage />} />
            
            <Route path="/login" element={<AuthenticationPage />} />

            <Route path="/reset-password" element={<AuthenticationPage />} />

            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;